// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js!./preference-context-menu.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../css-loader/dist/cjs.js!./preference-array.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../../css-loader/dist/cjs.js!./preference-file.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../../css-loader/dist/cjs.js!./preference-object.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../../css-loader/dist/cjs.js!./search-input.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

#preferences_container_widget .p-SplitPanel-handle {
  border-right: var(--theia-border-width) solid var(--theia-editorGroup-border);
}

#preferences_container_widget .p-TabBar-tabIcon {
  align-items: center;
  display: flex;
  line-height: var(--theia-content-line-height) !important;
}

/* UI View */

.theia-settings-container {
  max-width: 1000px;
  padding-top: 11px;
  display: grid;
  grid-template-areas:
    "header header"
    "tabbar tabbar"
    "navbar editor";
  grid-template-columns: minmax(150px, 280px) 1fr;
  grid-template-rows: 45px 45px 1fr;
}

.theia-settings-container
  .settings-main:not(.no-results)
  .settings-no-results-announcement {
  display: none;
}

.theia-settings-container .settings-main .hidden {
  display: none;
}

.theia-settings-container .settings-no-results-announcement {
  font-weight: bold;
  font-size: var(--theia-ui-font-size3);
  padding-left: var(--theia-ui-padding);
  margin: calc(2 * var(--theia-ui-padding)) 0px;
}

.theia-settings-container .preferences-searchbar-widget {
  grid-area: header;
  margin: 3px 24px 0px 24px;
}

.theia-settings-container .preferences-tabbar-widget {
  grid-area: tabbar;
  margin: 3px 24px 0px 24px;
}

.theia-settings-container .preferences-tabbar-widget.with-shadow {
  box-shadow: 0px 6px 5px -5px var(--theia-widget-shadow);
}

.theia-settings-container
  .preferences-tabbar-widget
  .preferences-scope-tab
  .p-TabBar-tabIcon:not(.preferences-folder-dropdown-icon) {
  display: none;
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab {
  background: var(--theia-editor-background);
  border-right: unset;
  border-bottom: var(--theia-border-width) solid
    var(--theia-tab-unfocusedInactiveForeground);
  border-top: none;
}

#theia-main-content-panel .theia-settings-container .tabbar-underline {
  width: 100%;
  position: absolute;
  top: calc(
    var(--theia-private-horizontal-tab-height) +
      var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2 - 1px
  );
  border-top: 1px solid var(--theia-tab-unfocusedInactiveForeground);
  z-index: -1;
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab {
  color: var(--theia-panelTitle-inactiveForeground);
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab:hover {
  color: var(--theia-panelTitle-activeForeground);
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab.p-mod-current {
  color: var(--theia-panelTitle-activeForeground);
  border-bottom: var(--theia-border-width) solid
    var(--theia-panelTitle-activeBorder);
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab.p-mod-current:not(.theia-mod-active) {
  border-top: unset;
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab.preferences-folder-tab
  .p-TabBar-tabLabel::after {
  content: "Folder";
  padding-left: 4px;
  font-size: 0.8em;
  color: var(--theia-tab-inactiveForeground);
}

#theia-main-content-panel
  .theia-settings-container
  #preferences-scope-tab-bar
  .preferences-scope-tab.preferences-folder-dropdown {
  position: relative;
  padding-right: 23px;
}

.preferences-folder-dropdown-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  right: var(--theia-ui-padding);
}

.theia-settings-container .preferences-editor-widget {
  grid-area: editor;
}

.theia-settings-container .preferences-editor-widget.full-pane {
  grid-column-start: 1;
  grid-column-end: 3;
}

.theia-settings-container .preferences-tree-widget {
  grid-area: navbar;
  padding-left: 31px;
}

.theia-settings-container .preferences-tree-widget .theia-mod-selected {
  font-weight: bold;
}

.theia-settings-container .preferences-tree-widget .theia-TreeNodeSegment {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 90%;
}

.theia-settings-container .settings-main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.theia-settings-container .settings-main-scroll-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 0 24px;
  flex: 1 1 auto;
}

.theia-settings-container .settings-main-sticky-misc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 1 50px;
}

.theia-settings-container .settings-main-sticky-misc .json-button > i {
  display: inline-block;
  background: var(--theia-icon-open-json) no-repeat;
  background-position-y: 1px;
  -webkit-filter: invert(1);
  filter: invert(1);
  height: var(--theia-icon-size);
  width: var(--theia-icon-size);
}

.theia-settings-container .settings-scope > label {
  margin-right: 12px;
}

.theia-settings-container .settings-section {
  padding-left: 0;
  padding-top: var(--theia-ui-padding);
  margin-top: calc(var(--theia-ui-padding) * -1);
}

.theia-settings-container .settings-section a {
  border: none;
  color: var(--theia-foreground);
  font-weight: 500;
  outline: 0;
  text-decoration: none;
}

.theia-settings-container .command-link {
  color: var(--theia-textLink-foreground);
}

.theia-settings-container .settings-section a:hover {
  text-decoration: underline;
}

.theia-settings-container .settings-section-category-title {
  font-weight: bold;
  font-size: var(--theia-ui-font-size3);
  padding-left: calc(2 * var(--theia-ui-padding));
}

.theia-settings-container .settings-section-subcategory-title {
  font-weight: bold;
  font-size: var(--theia-ui-font-size2);
  padding-left: calc(2 * var(--theia-ui-padding));
}

.theia-settings-container .settings-section > li {
  list-style-type: none;
  margin: var(--theia-ui-padding) 0px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;
}

.theia-settings-container li.single-pref {
  list-style-type: none;
  padding: 12px 14px 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
}

.theia-settings-container li.single-pref p {
  margin: 0;
}

.theia-settings-container li.single-pref:hover:not(:focus) {
  background-color: var(--theia-settings-rowHoverBackground);
}

.theia-settings-container li.single-pref:focus {
  background-color: var(--theia-settings-focusedRowBackground);
  outline: 1px solid var(--theia-settings-focusedRowBorder);
}

.theia-settings-container li.single-pref .pref-context-gutter {
  position: absolute;
  height: calc(100% - 36px);
  left: -22px;
  padding-right: 8px;
  border-right: 2px hidden;
}

.theia-settings-container .settings-context-menu-btn {
  opacity: 0;
  transition: opacity 0.5s;
}

.theia-settings-container
  .single-pref:focus-within
  .pref-context-gutter
  .settings-context-menu-btn,
.theia-settings-container
  .pref-name:hover
  + .pref-context-gutter
  .settings-context-menu-btn,
.theia-settings-container .pref-context-gutter:hover .settings-context-menu-btn,
.theia-settings-container
  .pref-context-gutter.show-cog
  .settings-context-menu-btn {
  opacity: 1;
}

.theia-settings-container
  li.single-pref
  .pref-context-gutter.theia-mod-item-modified {
  border-right: 2px solid var(--theia-settings-modifiedItemIndicator);
}

.theia-settings-container li.single-pref input[type="text"] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.theia-settings-container .settings-main {
  margin: 0;
}

.theia-settings-container .settings-main-sticky {
  top: 0;
  padding-top: calc(var(--theia-ui-padding));
  margin-top: calc(var(--theia-ui-padding) * -1);
  background-color: var(--theia-editor-background);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.theia-settings-container .pref-name {
  padding: 0;
  font-weight: bold;
}

.theia-settings-container .preference-leaf-headline-prefix {
  color: var(--theia-descriptionForeground);
}

.preferences-tree-spacer {
  padding-left: calc(var(--theia-ui-padding) / 2);
  padding-right: calc(var(--theia-ui-padding) / 2);
  min-width: var(--theia-icon-size);
  min-height: var(--theia-icon-size);
}

.theia-settings-container .pref-description {
  padding: var(--theia-ui-padding) 0;
  color: var(--theia-descriptionForeground);
  line-height: 18px;
}

.theia-settings-container .pref-description a {
  text-decoration-line: none;
  cursor: pointer;
}

.theia-settings-container .theia-select:focus {
  outline-width: 1px;
  outline-style: solid;
  outline-offset: -1px;
  opacity: 1 !important;
  outline-color: var(--theia-focusBorder);
}

.theia-settings-container .theia-input[type="text"] {
  border: 1px solid var(--theia-dropdown-border);
}

.theia-settings-container .theia-input[type="checkbox"]:focus,
.theia-settings-container .theia-input[type="number"]:focus {
  outline-width: 1px;
}

.theia-settings-container .theia-input[type="checkbox"] {
  margin-left: 0;
}

/* Remove the spinners from input[type = number] on Firefox. */
.theia-settings-container .theia-input[type="number"] {
  -webkit-appearance: textfield;
  border: 1px solid var(--theia-dropdown-border);
}

/* Remove the webkit spinners from input[type = number] on all browsers except Firefox. */
.theia-settings-container input::-webkit-outer-spin-button,
.theia-settings-container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dialogContent .error:not(:empty),
.theia-settings-container .pref-content-container .pref-input .pref-input-container .pref-error-notification {
  border-style: solid;
  border-width: 1px;
  border-color: var(--theia-inputValidation-errorBorder);
  background-color: var(--theia-inputValidation-errorBackground);
  width: 100%;
  box-sizing: border-box;
  padding: var(--theia-ui-padding);
}

.theia-settings-container
  .pref-content-container
  .pref-input
  .pref-input-container {
  display: flex;
  flex-direction: column;
}

.theia-settings-container .pref-content-container a.theia-json-input {
  text-decoration: underline;
  color: var(--theia-titleBar-activeForeground);
}

.theia-settings-container .pref-content-container a.theia-json-input:hover {
  text-decoration: none;
  cursor: pointer;
}

.theia-settings-container .pref-content-container {
  width: 100%;
}

.theia-settings-container .pref-content-container .pref-input {
  padding: var(--theia-ui-padding) 0;
  width: 100%;
  max-width: 320px;
}

.theia-settings-container .pref-content-container .pref-input > select,
.theia-settings-container
  .pref-content-container
  .pref-input
  > input:not([type="checkbox"]) {
  width: 100%;
}

/* These specifications for the boolean class ensure that the
    checkbox is rendered to the left of the description.
*/
.theia-settings-container .pref-content-container.boolean {
  display: grid;
  grid-template-columns: 20px 1fr;
}

.theia-settings-container .pref-content-container.boolean .pref-description {
  grid-column-start: 2;
  grid-row-start: 1;
}

.theia-settings-container .pref-content-container.boolean .pref-input {
  grid-column-start: 1;
  grid-row-start: 1;
  margin: 0;
}

.theia-settings-container .settings-section > li:last-child {
  margin-bottom: 20px;
}

.theia-settings-container .preference-leaf-headline-suffix {
  font-weight: normal;
  color: var(--theia-descriptionForeground);
}

.theia-settings-container .preference-leaf-headline-suffix::before {
  content: " (";
}

.theia-settings-container .preference-leaf-headline-suffix::after {
  content: ")";
}

.theia-settings-container .preference-scope-underlined {
  text-decoration: underline;
  cursor: pointer;
}

.theia-settings-container
  .preference-modified-scope-wrapper:not(:last-child)::after {
  content: ", ";
}

/** Select component */

.theia-settings-container .theia-select-component {
  height: 26px;
  width: 100%;
  max-width: 320px;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/preferences/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,wDAAwD;AAC1D;;AAEA,YAAY;;AAQZ;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb;;;mBAGiB;EACjB,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,0CAA0C;EAC1C,mBAAmB;EACnB;gDAC8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;;;GAGC;EACD,kEAAkE;EAClE,WAAW;AACb;;AAEA;;;;EAIE,iDAAiD;AACnD;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;;;EAIE,+CAA+C;EAC/C;wCACsC;AACxC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,4DAA4D;EAC5D,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,UAAU;AACZ;;AAEA;;;EAGE,mEAAmE;AACrE;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;EACN,0CAA0C;EAC1C,8CAA8C;EAC9C,gDAAgD;EAChD,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;EAChD,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA,yFAAyF;AACzF;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,sDAAsD;EACtD,8DAA8D;EAC9D,WAAW;EACX,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA,sBAAsB;;AAEtB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n#preferences_container_widget .p-SplitPanel-handle {\n  border-right: var(--theia-border-width) solid var(--theia-editorGroup-border);\n}\n\n#preferences_container_widget .p-TabBar-tabIcon {\n  align-items: center;\n  display: flex;\n  line-height: var(--theia-content-line-height) !important;\n}\n\n/* UI View */\n\n@import url(\"./preference-context-menu.css\");\n@import url(\"./preference-array.css\");\n@import url(\"./preference-file.css\");\n@import url(\"./preference-object.css\");\n@import url(\"./search-input.css\");\n\n.theia-settings-container {\n  max-width: 1000px;\n  padding-top: 11px;\n  display: grid;\n  grid-template-areas:\n    \"header header\"\n    \"tabbar tabbar\"\n    \"navbar editor\";\n  grid-template-columns: minmax(150px, 280px) 1fr;\n  grid-template-rows: 45px 45px 1fr;\n}\n\n.theia-settings-container\n  .settings-main:not(.no-results)\n  .settings-no-results-announcement {\n  display: none;\n}\n\n.theia-settings-container .settings-main .hidden {\n  display: none;\n}\n\n.theia-settings-container .settings-no-results-announcement {\n  font-weight: bold;\n  font-size: var(--theia-ui-font-size3);\n  padding-left: var(--theia-ui-padding);\n  margin: calc(2 * var(--theia-ui-padding)) 0px;\n}\n\n.theia-settings-container .preferences-searchbar-widget {\n  grid-area: header;\n  margin: 3px 24px 0px 24px;\n}\n\n.theia-settings-container .preferences-tabbar-widget {\n  grid-area: tabbar;\n  margin: 3px 24px 0px 24px;\n}\n\n.theia-settings-container .preferences-tabbar-widget.with-shadow {\n  box-shadow: 0px 6px 5px -5px var(--theia-widget-shadow);\n}\n\n.theia-settings-container\n  .preferences-tabbar-widget\n  .preferences-scope-tab\n  .p-TabBar-tabIcon:not(.preferences-folder-dropdown-icon) {\n  display: none;\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab {\n  background: var(--theia-editor-background);\n  border-right: unset;\n  border-bottom: var(--theia-border-width) solid\n    var(--theia-tab-unfocusedInactiveForeground);\n  border-top: none;\n}\n\n#theia-main-content-panel .theia-settings-container .tabbar-underline {\n  width: 100%;\n  position: absolute;\n  top: calc(\n    var(--theia-private-horizontal-tab-height) +\n      var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2 - 1px\n  );\n  border-top: 1px solid var(--theia-tab-unfocusedInactiveForeground);\n  z-index: -1;\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab {\n  color: var(--theia-panelTitle-inactiveForeground);\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab:hover {\n  color: var(--theia-panelTitle-activeForeground);\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab.p-mod-current {\n  color: var(--theia-panelTitle-activeForeground);\n  border-bottom: var(--theia-border-width) solid\n    var(--theia-panelTitle-activeBorder);\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab.p-mod-current:not(.theia-mod-active) {\n  border-top: unset;\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab.preferences-folder-tab\n  .p-TabBar-tabLabel::after {\n  content: \"Folder\";\n  padding-left: 4px;\n  font-size: 0.8em;\n  color: var(--theia-tab-inactiveForeground);\n}\n\n#theia-main-content-panel\n  .theia-settings-container\n  #preferences-scope-tab-bar\n  .preferences-scope-tab.preferences-folder-dropdown {\n  position: relative;\n  padding-right: 23px;\n}\n\n.preferences-folder-dropdown-icon {\n  width: 15px;\n  height: 15px;\n  position: absolute;\n  right: var(--theia-ui-padding);\n}\n\n.theia-settings-container .preferences-editor-widget {\n  grid-area: editor;\n}\n\n.theia-settings-container .preferences-editor-widget.full-pane {\n  grid-column-start: 1;\n  grid-column-end: 3;\n}\n\n.theia-settings-container .preferences-tree-widget {\n  grid-area: navbar;\n  padding-left: 31px;\n}\n\n.theia-settings-container .preferences-tree-widget .theia-mod-selected {\n  font-weight: bold;\n}\n\n.theia-settings-container .preferences-tree-widget .theia-TreeNodeSegment {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 90%;\n}\n\n.theia-settings-container .settings-main {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-settings-container .settings-main-scroll-container {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 24px;\n  flex: 1 1 auto;\n}\n\n.theia-settings-container .settings-main-sticky-misc {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 1 50px;\n}\n\n.theia-settings-container .settings-main-sticky-misc .json-button > i {\n  display: inline-block;\n  background: var(--theia-icon-open-json) no-repeat;\n  background-position-y: 1px;\n  -webkit-filter: invert(1);\n  filter: invert(1);\n  height: var(--theia-icon-size);\n  width: var(--theia-icon-size);\n}\n\n.theia-settings-container .settings-scope > label {\n  margin-right: 12px;\n}\n\n.theia-settings-container .settings-section {\n  padding-left: 0;\n  padding-top: var(--theia-ui-padding);\n  margin-top: calc(var(--theia-ui-padding) * -1);\n}\n\n.theia-settings-container .settings-section a {\n  border: none;\n  color: var(--theia-foreground);\n  font-weight: 500;\n  outline: 0;\n  text-decoration: none;\n}\n\n.theia-settings-container .command-link {\n  color: var(--theia-textLink-foreground);\n}\n\n.theia-settings-container .settings-section a:hover {\n  text-decoration: underline;\n}\n\n.theia-settings-container .settings-section-category-title {\n  font-weight: bold;\n  font-size: var(--theia-ui-font-size3);\n  padding-left: calc(2 * var(--theia-ui-padding));\n}\n\n.theia-settings-container .settings-section-subcategory-title {\n  font-weight: bold;\n  font-size: var(--theia-ui-font-size2);\n  padding-left: calc(2 * var(--theia-ui-padding));\n}\n\n.theia-settings-container .settings-section > li {\n  list-style-type: none;\n  margin: var(--theia-ui-padding) 0px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n}\n\n.theia-settings-container li.single-pref {\n  list-style-type: none;\n  padding: 12px 14px 18px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.theia-settings-container li.single-pref p {\n  margin: 0;\n}\n\n.theia-settings-container li.single-pref:hover:not(:focus) {\n  background-color: var(--theia-settings-rowHoverBackground);\n}\n\n.theia-settings-container li.single-pref:focus {\n  background-color: var(--theia-settings-focusedRowBackground);\n  outline: 1px solid var(--theia-settings-focusedRowBorder);\n}\n\n.theia-settings-container li.single-pref .pref-context-gutter {\n  position: absolute;\n  height: calc(100% - 36px);\n  left: -22px;\n  padding-right: 8px;\n  border-right: 2px hidden;\n}\n\n.theia-settings-container .settings-context-menu-btn {\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n\n.theia-settings-container\n  .single-pref:focus-within\n  .pref-context-gutter\n  .settings-context-menu-btn,\n.theia-settings-container\n  .pref-name:hover\n  + .pref-context-gutter\n  .settings-context-menu-btn,\n.theia-settings-container .pref-context-gutter:hover .settings-context-menu-btn,\n.theia-settings-container\n  .pref-context-gutter.show-cog\n  .settings-context-menu-btn {\n  opacity: 1;\n}\n\n.theia-settings-container\n  li.single-pref\n  .pref-context-gutter.theia-mod-item-modified {\n  border-right: 2px solid var(--theia-settings-modifiedItemIndicator);\n}\n\n.theia-settings-container li.single-pref input[type=\"text\"] {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.theia-settings-container .settings-main {\n  margin: 0;\n}\n\n.theia-settings-container .settings-main-sticky {\n  top: 0;\n  padding-top: calc(var(--theia-ui-padding));\n  margin-top: calc(var(--theia-ui-padding) * -1);\n  background-color: var(--theia-editor-background);\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.theia-settings-container .pref-name {\n  padding: 0;\n  font-weight: bold;\n}\n\n.theia-settings-container .preference-leaf-headline-prefix {\n  color: var(--theia-descriptionForeground);\n}\n\n.preferences-tree-spacer {\n  padding-left: calc(var(--theia-ui-padding) / 2);\n  padding-right: calc(var(--theia-ui-padding) / 2);\n  min-width: var(--theia-icon-size);\n  min-height: var(--theia-icon-size);\n}\n\n.theia-settings-container .pref-description {\n  padding: var(--theia-ui-padding) 0;\n  color: var(--theia-descriptionForeground);\n  line-height: 18px;\n}\n\n.theia-settings-container .pref-description a {\n  text-decoration-line: none;\n  cursor: pointer;\n}\n\n.theia-settings-container .theia-select:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: -1px;\n  opacity: 1 !important;\n  outline-color: var(--theia-focusBorder);\n}\n\n.theia-settings-container .theia-input[type=\"text\"] {\n  border: 1px solid var(--theia-dropdown-border);\n}\n\n.theia-settings-container .theia-input[type=\"checkbox\"]:focus,\n.theia-settings-container .theia-input[type=\"number\"]:focus {\n  outline-width: 1px;\n}\n\n.theia-settings-container .theia-input[type=\"checkbox\"] {\n  margin-left: 0;\n}\n\n/* Remove the spinners from input[type = number] on Firefox. */\n.theia-settings-container .theia-input[type=\"number\"] {\n  -webkit-appearance: textfield;\n  border: 1px solid var(--theia-dropdown-border);\n}\n\n/* Remove the webkit spinners from input[type = number] on all browsers except Firefox. */\n.theia-settings-container input::-webkit-outer-spin-button,\n.theia-settings-container input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.dialogContent .error:not(:empty),\n.theia-settings-container .pref-content-container .pref-input .pref-input-container .pref-error-notification {\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--theia-inputValidation-errorBorder);\n  background-color: var(--theia-inputValidation-errorBackground);\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--theia-ui-padding);\n}\n\n.theia-settings-container\n  .pref-content-container\n  .pref-input\n  .pref-input-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-settings-container .pref-content-container a.theia-json-input {\n  text-decoration: underline;\n  color: var(--theia-titleBar-activeForeground);\n}\n\n.theia-settings-container .pref-content-container a.theia-json-input:hover {\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.theia-settings-container .pref-content-container {\n  width: 100%;\n}\n\n.theia-settings-container .pref-content-container .pref-input {\n  padding: var(--theia-ui-padding) 0;\n  width: 100%;\n  max-width: 320px;\n}\n\n.theia-settings-container .pref-content-container .pref-input > select,\n.theia-settings-container\n  .pref-content-container\n  .pref-input\n  > input:not([type=\"checkbox\"]) {\n  width: 100%;\n}\n\n/* These specifications for the boolean class ensure that the\n    checkbox is rendered to the left of the description.\n*/\n.theia-settings-container .pref-content-container.boolean {\n  display: grid;\n  grid-template-columns: 20px 1fr;\n}\n\n.theia-settings-container .pref-content-container.boolean .pref-description {\n  grid-column-start: 2;\n  grid-row-start: 1;\n}\n\n.theia-settings-container .pref-content-container.boolean .pref-input {\n  grid-column-start: 1;\n  grid-row-start: 1;\n  margin: 0;\n}\n\n.theia-settings-container .settings-section > li:last-child {\n  margin-bottom: 20px;\n}\n\n.theia-settings-container .preference-leaf-headline-suffix {\n  font-weight: normal;\n  color: var(--theia-descriptionForeground);\n}\n\n.theia-settings-container .preference-leaf-headline-suffix::before {\n  content: \" (\";\n}\n\n.theia-settings-container .preference-leaf-headline-suffix::after {\n  content: \")\";\n}\n\n.theia-settings-container .preference-scope-underlined {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.theia-settings-container\n  .preference-modified-scope-wrapper:not(:last-child)::after {\n  content: \", \";\n}\n\n/** Select component */\n\n.theia-settings-container .theia-select-component {\n  height: 26px;\n  width: 100%;\n  max-width: 320px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
